<template>
  <b-card>
    <slot name="top"></slot>
    <b-row>
      <b-col cols="1">
        <slot name="topLeft">
          <h-b-action
            v-if="filterInstance"
            :positive="false"
            icon="bx bx-slider-alt"
            text="Filtres"
            @click.native="openFilters((leftSlider = !leftSlider))"
          ></h-b-action>
        </slot>
      </b-col>
      <b-col cols="8">
        <slot name="topMiddle"></slot>
      </b-col>
      <b-col cols="3">
        <slot name="topRight">
          <h-f-design-search-field v-model="searchInput" placeholder="Rechercher..."> </h-f-design-search-field>
        </slot>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="6"></b-col>
      <b-col class="d-flex justify-content-end" cols="6">
        <slot name="actionButtons">
          <h-b-action
            v-if="tableSpecs.actions.add"
            :positive="false"
            icon="bx bx-plus"
            text="Ajouter"
            @click.native="openForm(false)"
          >
          </h-b-action>
        </slot>
      </b-col>
    </b-row>
    <b-row>
      <h-t-table :nb-results="count" :loaded="loaded" class="sm mt-4">
        <template #table-head>
          <h-t-table-header-action
            v-if="
              tableSpecs.actions.select &&
              ($hidderComponent(tableSpecs.scope + ':delete', false) ||
                $hidderComponent(tableSpecs.scope + ':full', false) ||
                $hidderComponent(tableSpecs.scope + ':update', false))
            "
            side="left"
          >
            <b-form-checkbox
              v-if="tableSpecs.actions.select"
              v-model="selectAll"
              :unchecked-value="false"
              :value="true"
              name="checkbox-1"
            />
          </h-t-table-header-action>
          <h-t-table-header
            v-for="(element, subIndex) in tableSpecs.ressourceTable"
            :key="subIndex"
            @click.native="openForm(true, ressource)"
            >{{ element.label }}</h-t-table-header
          >
          <h-t-table-header-action v-if="tableSpecs.actions.delete || tableSpecs.actions.edit"
            >Actions</h-t-table-header-action
          >
        </template>
        <template #table-body>
          <tr v-for="(ressource, index) in ressourceList" :key="index" class="cursor-pointer">
            <h-t-table-element-action
              v-if="
                tableSpecs.actions.select &&
                ($hidderComponent(tableSpecs.scope + ':delete', false) ||
                  $hidderComponent(tableSpecs.scope + ':full', false) ||
                  $hidderComponent(tableSpecs.scope + ':update', false))
              "
              side="left"
              :class="ressource.rulesClassColor"
            >
              <b-form-checkbox
                v-if="tableSpecs.actions.select"
                v-model="ressource.selected"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
                @change="selectRessource(index)"
              />
              <b-form-checkbox
                v-if="tableSpecs.actions.switch"
                v-model="ressource[tableSpecs.actions.switch.model]"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
                switch
                @change="switchResource(ressource, tableSpecs.actions.switch.model)"
              />
            </h-t-table-element-action>
            <h-t-table-element
              v-for="(element, subIndex) in tableSpecs.ressourceTable"
              v-bind="element.customAttributes"
              :key="subIndex"
              :class="getRulesClass(ressource, element)"
              @click.native="openForm(true, ressource)"
            >
              <router-link
                v-if="element.link"
                :to="{ name: element.link.name, params: { [element.link.param]: ressource[element.link.lookup] } }"
              >
                <component
                  :is="element.component"
                  v-if="element.component"
                  :label="_.get(ressource, element.model)"
                  :title="_.get(ressource, element.model)"
                  :bg-color="
                    element.mappingClassColor.hasOwnProperty(_.get(ressource, element.model))
                      ? element.mappingClassColor[_.get(ressource, element.model)]
                      : 'success'
                  "
                  v-bind="element.customAttributes"
                >
                  <div v-if="element.insideLabel">
                    <div v-if="element.type === 'date'">
                      {{ _.get(ressource, element.model) | formatDate }}
                    </div>
                    <div v-else>{{ _.get(ressource, element.model) }} {{ element.suffix }}</div>
                  </div>
                </component>
                <div v-else>
                  <div v-if="element.type === 'date'">
                    {{ _.get(ressource, element.model) | formatDate }}
                  </div>
                  <div v-else>{{ _.get(ressource, element.model) }} {{ element.suffix }}</div>
                </div>
              </router-link>
              <div v-else>
                <component
                  :is="element.component"
                  v-if="element.component"
                  :label="_.get(ressource, element.model)"
                  :title="_.get(ressource, element.model)"
                  :bg-color="
                    element.mappingClassColor.hasOwnProperty(_.get(ressource, element.model))
                      ? element.mappingClassColor[_.get(ressource, element.model)]
                      : 'success'
                  "
                  v-bind="element.customAttributes"
                >
                  <div v-if="element.insideLabel">
                    <div v-if="element.type === 'date'">
                      {{ _.get(ressource, element.model) | formatDate }}
                    </div>
                    <div v-else>{{ _.get(ressource, element.model) }} {{ element.suffix }}</div>
                  </div>
                </component>
                <div v-else>
                  <div v-if="element.type === 'date'">
                    {{ _.get(ressource, element.model) | formatDate }}
                  </div>
                  <div v-else-if="element.type === 'boolean'">
                    {{ _.get(ressource, element.model) | formatBoolean }}
                  </div>
                  <div v-else>{{ _.get(ressource, element.model) }} {{ element.suffix }}</div>
                </div>
              </div>
            </h-t-table-element>

            <h-t-table-element-action
              v-if="
                (tableSpecs.actions.delete || tableSpecs.actions.edit) &&
                ($hidderComponent(tableSpecs.scope + ':delete', false) ||
                  $hidderComponent(tableSpecs.scope + ':full', false) ||
                  $hidderComponent(tableSpecs.scope + ':update', false))
              "
            >
              <i
                v-if="
                  (tableSpecs.actions.edit && $hidderComponent(tableSpecs.scope + ':full', false)) ||
                  $hidderComponent(tableSpecs.scope + ':update', false)
                "
                class="bx bx-edit-alt text-primary"
                @click="openForm(true, ressource)"
              />
              <i
                v-if="
                  (tableSpecs.actions.delete && $hidderComponent(tableSpecs.scope + ':delete', false)) ||
                  $hidderComponent(tableSpecs.scope + ':full', false)
                "
                class="bx bx-trash-alt text-primary"
                @click="deleteRessource(index)"
              />
            </h-t-table-element-action>
          </tr>
        </template>
      </h-t-table>
    </b-row>
    <h-e-paging :key="pageKey" v-model="page" :per-page="pageSize" :rows="count" class="w-100 float-right" />
  </b-card>
</template>
<script>
/*
  Auto-filter component

*/
import { FunctionHelpers } from '@/node-sdk'
import moment from 'moment'
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash'

export default {
  name: 'auto-table',
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    formatBoolean(boolean) {
      if (boolean) {
        return 'Oui'
      }
      return 'Non'
    },
  },
  props: {
    tableSpecs: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    filterInstance: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      ressourceList: [],
      selectAll: false,
      loaded: false,
      leftSlider: false,
      rightSlider: false,
      searchInput: '',
      count: 0,
      pageSize: 30,
      page: 1,
      pageKey: 0,
    }
  },
  computed: {
    _() {
      return _
    },
  },
  watch: {
    async page() {
      await this.getRessource()
    },
    async searchInput() {
      await this.getRessource()
    },
    value() {
      this.loaded = this.value
    },
    selectAll() {
      if (this.selectAll) {
        for (let i = 0; i < this.ressourceList.length; i++) {
          this.ressourceList[i].selected = true
        }
        this.numberSelected = this.ressourceList.length
      } else {
        for (let i = 0; i < this.ressourceList.length; i++) {
          this.ressourceList[i].selected = false
        }
        this.numberSelected = 0
      }
      this.$emit('onSelectAll', this.ressourceList)
    },
  },
  async mounted() {
    this.ressourceList = this.getRessource()
  },
  methods: {
    getRulesClass(element, ressource) {
      let matchClass
      if (ressource.rulesClass) {
        ressource.rulesClass.forEach((rule) => {
          // eslint-disable-next-line no-eval
          if (eval(rule.condition)) {
            matchClass = rule.value
          }
        })
      }
      return matchClass
    },
    switchResource(ressource, model) {
      this.$emit('onSwitchResource', ressource, model)
    },
    openFilters(leftSlider) {
      this.$emit('openFilters', leftSlider)
    },
    openForm(open, ressource) {
      if (this.tableSpecs.actions.edit) {
        if (ressource && !this.$hidderComponent(`${this.tableSpecs.scope}:update`, false)) {
          this.$emit('openForm', open, ressource)
        } else if (!ressource && !this.$hidderComponent(`${this.tableSpecs.scope}:create`, false)) {
          this.$emit('openForm', open, ressource)
        }
      }
    },
    selectRessource(index) {
      if (this.ressourceList[index].selected === true) {
        this.$set(this.ressourceList[index], 'selected', false)
        this.numberSelected -= 1
      } else {
        this.$set(this.ressourceList[index], 'selected', true)
        this.numberSelected += 1
      }
      this.$emit('selectRessource', index)
    },
    async getRessource() {
      this.loaded = false
      let params = {}
      if (this.filterInstance) {
        params = FunctionHelpers.createRequestParams(
          this.filterInstance.form,
          this.filterInstance.active,
          this.page,
          this.searchInput,
          this.pageSize,
        )
      } else {
        params = FunctionHelpers.createRequestParams({}, {}, this.page, this.searchInput)
      }

      if (this.tableSpecs.additionnalParams) {
        params = { ...params, ...this.tableSpecs.additionnalParams }
      }
      let stats = {}
      ;[this.ressourceList, this.count, stats] = await this.tableSpecs.ressourceClass.get({ params })
      this.loaded = true
      this.$emit('onRessourceListLoaded', { ressourceList: this.ressourceList, count: this.count, stats })
    },
    deleteRessource(index) {
      FunctionHelpers.confirmModal('Supprimer').then(async (res) => {
        if (res.value) {
          if (this.ressourceList[index].selected) {
            this.numberSelected -= 1
          }
          await this.tableSpecs.ressourceClass.delete(this.ressourceList[index].id)
          await this.getRessource()
        }
      })
    },
  },
}
</script>

<style scoped></style>
